import React, { Component } from 'react';
import '../css/PickingItemInfo.css';
import { NotPickedReason } from './NotPickedReason';
import { faImage, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AdditionalInfo } from './AdditionalInfo';

export class CSItemInfo extends Component {

    constructor(props) {
        super(props);
        this.lineId = this.props.item.lineId;
        this.getQtyText = this.getQtyText.bind(this);
        this.canEditQty = this.canEditQty.bind(this);
    }

    getQtyText(item) {
        if (item.qtyCancelled > 0) {
            return (<b>Cancelled: {item.qtyCancelled}</b>)
        } else if (item.isBackordered) {
            return (<b>Backordered: {item.qtyBackordered}</b>)
        } else {
            return (<b>Remain: {item.quantity}</b>)
        }
    }

    canEditQty(item) {
        var canEdit =
            this.props.canEditQty
            &&
            (item.quantity + item.quantityPicked) >= this.props.multiScanThreshold
            &&
            !item.pickLater
            &&
            !item.isBackordered
            &&
            !item.needsSerialNum
            &&
            !item.isGiftCard;
        return canEdit;
    }

    render() {
        var lineStatusClass = this.props.getLineStatus(this.props.item);
        var lineId = this.props.item.lineId;
        var item = this.props.item;
        var itemId = item.itemId;
        var itemInfo = this.props.itemInfo[itemId];
        var sortBy = this.props.sortBy;
        var sortByValue = itemInfo[sortBy];
        var showShortSortBy = itemInfo.showShortSortBy || sortByValue.length <= 20;
        var shortSortByValue = sortByValue.length < 20 ? sortByValue : sortByValue.substr(0, 20) + "...";
        //Leave it blank, as it is confusing from a user perspective
        /*if (!sortByValue & sortByFields.length > 1) {
            for (var i = 1; i < sortByFields.length; i++) {
                sortByValue = itemInfo[item.itemId][sortByFields[i]]
                if (sortByValue) {
                    break;
                }
            }
        }*/
        var hasImages = itemInfo.imageURLs.length > 0;
        var itemName = item.itemName;
        var itemOptions = itemInfo.itemOptions;
        if (item.doSubstitution) {
            itemName = "*SUB*" + item.subItemInfo.displayName + "*SUB*"
        }
        return (
            <div className={lineStatusClass} id={lineId} key={lineId}>
                <div className="grid-container">
                    <div onClick={() => this.props.toggleSortByLength(itemId)} className="sortBy">
                        {
                            (showShortSortBy)
                            ?
                            <b className="shortSortBy">{shortSortByValue}</b>
                            :
                            <b className="longSortBy">{sortByValue}</b>
                        }
                    </div>
                    <div className="buttons">
                        {
                            (
                                item.quantity > 0
                                &&
                                (!item.isBackordered)
                            )
                            &&
                            <NotPickedReason
                                lineId={lineId}
                                doNotPick={this.props.doNotPick}
                                backorderItem={this.props.backorderItem}
                                showBackorder={this.props.canBackorder}
                                canCancel={this.props.canCancel}
                                cancelItem={this.props.cancelItem}
                                pickLater={item.pickLater}
                            />
                        }
                        {
                            item.qtyCancelled > 0 && <button onClick={() => this.props.undoCancel(lineId)}>Undo Cancel</button>
                        }
                        {
                            item.isBackordered && <button onClick={() => this.props.undoBackorder(lineId)}>Undo Backorder</button>
                        }
                    </div>
                    <div className="itemName">
                        {
                            hasImages
                            &&
                            <FontAwesomeIcon className="imageIcon" onClick={() => this.props.showImage(item.itemId)} size="lg" icon={faImage} />
                        }
                            <b>{itemName}</b>
                        {
                            itemOptions
                            &&
                            (
                                <div>
                                    <b className="itemOptions">{itemOptions}</b>
                                </div>
                            )
                        }
                    </div>
                    <AdditionalInfo
                        item={item}
                        additionalInfoOptions={this.props.additionalInfoOptions}
                        editInputField={this.props.editInputField}
                        updateGiftCardNum={this.props.updateGiftCardNum}
                        updateSerialNum={this.props.updateSerialNum}
                    />
                    <div className="qtyInfo">
                        {this.getQtyText(item)}
                        <b>Picked: {item.quantityPicked} {this.canEditQty(item) && <b onClick={(e) => { this.props.startBinQtyEdit(item.lineId) }}><FontAwesomeIcon icon={faPenToSquare} /></b>}</b> 
                        <b>QOH: {itemInfo.locationQtyInfo[this.props.location] ? itemInfo.locationQtyInfo[this.props.location].qtyOnHand : 0 }</b>
                    </div>
                    <div className="slot"><h1>{item.slot}</h1></div>
                </div>

            </div>
        );
    }
}
